import { listFieldTransformerRegistry } from "sulu-admin-bundle/containers";

import CellTransformer from "./CellTransformer";
import CustomDateFieldTransformer from "./CustomDateFieldTransformer";
import CustomTimeFieldTransformer from "./CustomTimeFieldTransformer";
import CheckBoxTransformer from "./CheckBoxTransformer";
import ShirtTransformer from "./ShirtTransformer";
import SelectTransformer from "./SelectTransformer";
import JsonHeadlineTransformer from "./Json";
import ArrayImplodeTransformer from "./ArrayImplode";
import PassportColorTransformer from "./PassportColorTransformer";
import PassportRequestTypeTransformer from "./PassportRequestTypeTransformer";
import UmpireRequestStatusTransformer from "./UmpireRequestStatusTransformer";
import LicenseValidityEnum from "./LicenseValidityEnum";

const registerTransformers = () => {
    listFieldTransformerRegistry.add("neki_transformer", new CellTransformer());
    listFieldTransformerRegistry.add(
        "custom_date",
        new CustomDateFieldTransformer()
    );
    listFieldTransformerRegistry.add(
        "custom_time",
        new CustomTimeFieldTransformer()
    );
    listFieldTransformerRegistry.add(
        "license_validity_enum",
        new LicenseValidityEnum()
    );
    listFieldTransformerRegistry.add(
        "checkbox_transformer",
        new CheckBoxTransformer()
    );
    listFieldTransformerRegistry.add(
        "shirt_transformer",
        new ShirtTransformer()
    );
    listFieldTransformerRegistry.add(
        "select_transformer",
        new SelectTransformer()
    );
    listFieldTransformerRegistry.add(
        "colored_text_validation",
        new PassportColorTransformer()
    );
    listFieldTransformerRegistry.add(
        "passport_request_type",
        new PassportRequestTypeTransformer()
    );
    listFieldTransformerRegistry.add(
        "umpire_request_status",
        new UmpireRequestStatusTransformer()
    );
    listFieldTransformerRegistry.add(
        "json.headline",
        new JsonHeadlineTransformer()
    );
    listFieldTransformerRegistry.add(
        "array.implode",
        new ArrayImplodeTransformer()
    );
};

export default registerTransformers;
